import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Outlet, Route, Routes } from "react-router-dom";

import { PublicLayout } from "@/layouts/public-layout";
import AdminDashboard from "@/pages/admin/admin-dashboard";
import AdminLogin from "@/pages/admin/admin-login";
import PrintCouponPage from "@/pages/admin/print-coupon";
import AdminRegistrations from "@/pages/admin/registrations";
import AdminScanner from "@/pages/admin/scanner";
import CouponPage from "@/pages/coupon";
import UserDashboard from "@/pages/dashboard/user-dashboard";
import Home from "@/pages/home";
import Login from "@/pages/login";
import LookupPage from "@/pages/lookup";
import { NotFound } from "@/pages/not-found";
import RegisterPage from "@/pages/register";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <PublicLayout>
                  <Home />
                </PublicLayout>
              }
            />
            <Route
              path="/register"
              element={
                <PublicLayout>
                  <RegisterPage />
                </PublicLayout>
              }
            />
            <Route
              path="/login"
              element={
                <PublicLayout>
                  <Login />
                </PublicLayout>
              }
            />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/lookup"
              element={
                <PublicLayout>
                  <LookupPage />
                </PublicLayout>
              }
            />
            <Route
              path="/coupon/:id"
              element={
                <PublicLayout>
                  <CouponPage />
                </PublicLayout>
              }
            />
            <Route
              path="/coupon"
              element={
                <PublicLayout>
                  <CouponPage />
                </PublicLayout>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected requiredPermission="deployment:admin-panel:write">
                  <Outlet />
                </Protected>
              }
            >
              <Route path="" element={<AdminDashboard />} />
              <Route path="registrations" element={<AdminRegistrations />} />
              <Route path="scanner" element={<AdminScanner />} />
              <Route path="print-coupon/:id" element={<PrintCouponPage />} />
            </Route>
            <Route
              path="/dashboard"
              element={
                <Protected requiredPermission="deployment:user:write">
                  <Outlet />
                </Protected>
              }
            >
              <Route path="" element={<UserDashboard />} />
            </Route>
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
